module.exports = __webpack_public_path__ + "static/media/explore1.f860bcee.svg";